<template>
  <div class="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 relative">
    <!-- Animated Background -->
    <div class="fixed inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-emerald-900/20 via-transparent to-transparent pointer-events-none"></div>
    <div class="fixed inset-0 bg-grid-pattern opacity-10 pointer-events-none"></div>
    
    <!-- Floating Particles -->
    <div class="fixed inset-0 pointer-events-none">
      <div class="particle particle-1"></div>
      <div class="particle particle-2"></div>
      <div class="particle particle-3"></div>
      <div class="particle particle-4"></div>
      <div class="particle particle-5"></div>
    </div>

    <!-- Modern Sidebar Navigation -->
    <div class="sidebar fixed inset-y-0 left-0 z-50 bg-slate-800/90 backdrop-blur-xl border-r border-slate-700/50 flex flex-col overflow-y-auto custom-scrollbar" style="width: 288px; min-width: 288px;">
      <!-- Logo Section -->
      <div class="p-6 border-b border-slate-700/50 flex-shrink-0">
        <a :href="landingPageUrl" class="flex items-center space-x-3 group">
          <div class="w-12 h-12 bg-gradient-to-br from-emerald-400 to-cyan-400 rounded-2xl flex items-center justify-center shadow-lg shadow-emerald-500/25 group-hover:scale-105 transition-transform">
            <img src="/src/assets/images/icons/oilbuddy_logo.png" alt="OilBuddy" class="w-7 h-7">
          </div>
          <div>
            <span class="text-2xl font-bold bg-gradient-to-r from-emerald-400 to-cyan-400 bg-clip-text text-transparent group-hover:from-emerald-300 group-hover:to-cyan-300 transition-all duration-300">OilBuddy</span>
            <p class="text-xs text-slate-400 font-medium">AI Platform</p>
          </div>
        </a>
      </div>

      <!-- Navigation Menu -->
      <nav class="flex-1 px-4 py-6 space-y-2">
        <div class="mb-8">
          <div class="flex items-center px-3 py-2 text-xs font-semibold text-slate-400 uppercase tracking-wider mb-3">
            <span>Main</span>
          </div>
          <div class="space-y-1">
            <router-link :to="isSupervisor ? '/supervisor' : (isEmployee ? '/employee' : '/dashboard')" class="nav-item group">
              <img src="/src/assets/images/icons/growth chart.png" alt="Dashboard" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
            <span>Dashboard</span>
          </router-link>
          
            <router-link v-if="!isEmployee" to="/jobs" class="nav-item group">
              <img src="/src/assets/images/icons/handshake.png" alt="Job Marketplace" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
            <span>Job Marketplace</span>
          </router-link>

            <router-link v-if="isEmployee" to="/timesheets" class="nav-item group">
              <img src="/src/assets/images/icons/calendar with star.png" alt="Timesheets" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
            <span>Timesheets</span>
          </router-link>

            <router-link v-if="!isEmployee" to="/payments" class="nav-item group">
              <img src="/src/assets/images/icons/hand holding dollar coin.png" alt="Payments" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
            <span>Payments</span>
          </router-link>

            <router-link v-if="!isEmployee" to="/invoices" class="nav-item group">
              <img src="/src/assets/images/icons/todo-list.png" alt="Invoices" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
            <span>Invoices</span>
          </router-link>

            <router-link v-if="!isEmployee" to="/field-tickets" class="nav-item group">
              <img src="/src/assets/images/icons/checklist and pen.png" alt="Field Tickets" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
            <span>Field Tickets</span>
          </router-link>

            <router-link v-if="!isEmployee" to="/payroll" class="nav-item group">
              <img src="/src/assets/images/icons/money and dollar.png" alt="Payroll" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
            <span>Payroll</span>
          </router-link>

          </div>
        </div>

        <div class="mb-8">
          <div class="flex items-center px-3 py-2 text-xs font-semibold text-emerald-400/80 uppercase tracking-wider mb-3">
            <span>On Site</span>
          </div>
          <div class="space-y-1">
            <router-link :to="fieldLink('onsite')" class="nav-item group">
              <img src="/src/assets/images/icons/map location.png" alt="On Site Hub" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>On Site Hub</span>
            </router-link>
            <router-link v-if="isEmployee" :to="fieldLink('field-tickets')" class="nav-item group">
              <img src="/src/assets/images/icons/todo-list.png" alt="Field Tickets" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Field Tickets</span>
            </router-link>
            <router-link :to="fieldLink('dispatch')" class="nav-item group">
              <img src="/src/assets/images/icons/map location.png" alt="Dispatch" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>My Dispatch</span>
            </router-link>
            <router-link v-if="isSupervisor" to="/employee/daily-report" class="nav-item group">
              <img src="/src/assets/images/icons/checklist and pen.png" alt="Daily Report" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Daily Report</span>
            </router-link>
            <router-link :to="fieldLink('tank-sheets')" class="nav-item group">
              <img src="/src/assets/images/icons/todo-list.png" alt="Tank Sheets" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Tank Sheets</span>
            </router-link>
            <router-link v-if="isSupervisor" :to="fieldLink('tanks')" class="nav-item group">
              <img src="/src/assets/images/icons/oilbuddy_logo.png" alt="Tanks" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Tanks</span>
            </router-link>
            <router-link :to="fieldLink('tank-watch')" class="nav-item group">
              <img src="/src/assets/images/icons/map location.png" alt="Tank Watch" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Tank Watch</span>
            </router-link>
            <router-link :to="fieldLink('well-head-sheets')" class="nav-item group">
              <img src="/src/assets/images/icons/checklist and pen.png" alt="Well Head Sheets" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Well Head Sheets</span>
            </router-link>
            <router-link v-if="isEmployee" to="/safety" class="nav-item group">
              <img src="/src/assets/images/icons/shiny blue shield.png" alt="Safety" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Safety &amp; Compliance</span>
            </router-link>
          </div>
        </div>

        <div class="mb-8">
          <div class="flex items-center px-3 py-2 text-xs font-semibold text-slate-400 uppercase tracking-wider mb-3">
            <span>{{ isEmployee ? 'Work' : 'Business' }}</span>
          </div>
          <div class="space-y-1">
            <router-link to="/scheduling" class="nav-item group">
              <img src="/src/assets/images/icons/red calendar.png" alt="Scheduling" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
            <span>Scheduling</span>
          </router-link>

            <router-link v-if="!isEmployee" to="/safety" class="nav-item group">
              <img src="/src/assets/images/icons/shiny blue shield.png" alt="Safety & Compliance" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Safety & Compliance</span>
            </router-link>

            <router-link to="/profile" class="nav-item group">
              <img src="/src/assets/images/icons/checklist and pen.png" alt="Profile" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Profile</span>
            </router-link>

            <router-link v-if="!isEmployee" to="/tax-calculation" class="nav-item group">
              <img src="/src/assets/images/icons/gold dollar coin.png" alt="Tax Calculator" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Tax Calculator</span>
          </router-link>

            <router-link v-if="!isEmployee" to="/expenses" class="nav-item group">
              <img src="/src/assets/images/icons/money and dollar.png" alt="Expenses" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Expenses</span>
          </router-link>

                    <router-link v-if="!isEmployee" to="/ai-tax-optimization" class="nav-item group">
          <img src="/src/assets/images/icons/ai-powered financial research tools.png" alt="AI Tax Optimization" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
          <span>AI Tax Optimization</span>
        </router-link>

            <router-link v-if="!isEmployee" to="/bank" class="nav-item group">
              <img src="/src/assets/images/icons/bank office icon.png" alt="Bank Accounts" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Bank Accounts</span>
          </router-link>
          </div>
        </div>

        <div class="mb-8">
          <div class="flex items-center px-3 py-2 text-xs font-semibold text-slate-400 uppercase tracking-wider mb-3">
            <span>Tools</span>
          </div>
          <div class="space-y-1">
                        <router-link to="/ai-messaging" class="nav-item group">
              <img src="/src/assets/images/icons/ai chatbot window.png" alt="AI Assistant" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>AI Assistant</span>
            </router-link>

            <router-link to="/ai-agentic" class="nav-item group">
              <img src="/src/assets/images/icons/ai-agent.png" alt="AI Agents" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
            <span>AI Agents</span>
          </router-link>

            <router-link to="/knowledge" class="nav-item group">
              <img src="/src/assets/images/icons/books.png" alt="Knowledge Hub" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Knowledge Hub</span>
            </router-link>

            <router-link to="/blog" class="nav-item group">
              <img src="/src/assets/images/icons/megaphone announcement.png" alt="Industry News" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Industry News</span>
          </router-link>

            <router-link to="/store" class="nav-item group">
              <img src="/src/assets/images/icons/retail shop store.png" alt="Store" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Store</span>
            </router-link>

            <router-link to="/marketplace" class="nav-item group">
              <img src="/src/assets/images/icons/ai-marketplace.png" alt="AI Marketplace" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>AI Marketplace</span>
            </router-link>

            <router-link to="/integrations" class="nav-item group">
              <img src="/src/assets/images/icons/integrations.png" alt="Integrations" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Integrations</span>
            </router-link>
          </div>
        </div>

        <div class="mb-8">
          <div class="flex items-center px-3 py-2 text-xs font-semibold text-slate-400 uppercase tracking-wider mb-3">
            <span>Account</span>
          </div>
          <div class="space-y-1">
            <router-link to="/settings" class="nav-item group">
              <img src="/src/assets/images/icons/gear icon with neon.png" alt="Settings" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
            <span>Settings</span>
          </router-link>

            <router-link to="/user-support" class="nav-item group">
              <img src="/src/assets/images/icons/customer service.png" alt="Support" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Support</span>
            </router-link>
          </div>
        </div>
      </nav>

      <!-- User Profile Section -->
      <div class="p-4 border-t border-slate-700/50 flex-shrink-0">
        <div class="flex items-center space-x-3 p-3 bg-slate-700/30 rounded-xl hover:bg-slate-600/50 transition-all duration-200 cursor-pointer group mb-3" @click="handleProfileClick">
          <div class="w-10 h-10 bg-gradient-to-br from-emerald-400 to-cyan-400 rounded-xl flex items-center justify-center shadow-lg group-hover:scale-105 transition-transform">
            <span class="text-sm font-bold text-white">
              {{ userInitials || 'U' }}
            </span>
          </div>
          <div class="flex-1 min-w-0">
            <p class="text-sm font-semibold text-white group-hover:text-emerald-400 transition-colors truncate">{{ userName || 'User' }}</p>
            <p class="text-xs text-slate-400">{{ userTitle || 'Contractor' }}</p>
          </div>
          <svg class="w-4 h-4 text-slate-400 group-hover:text-emerald-400 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 9l4-4 4 4m0 6l-4 4-4-4"/>
          </svg>
        </div>
        
        <!-- Logout Button -->
        <button @click="logout" class="w-full flex items-center justify-center space-x-2 px-3 py-2 text-red-400 hover:text-red-300 hover:bg-red-500/10 rounded-lg transition-all duration-200">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
          </svg>
          <span class="text-sm font-medium">Sign Out</span>
        </button>
      </div>
    </div>

    <!-- Main Content Area -->
    <div class="ml-72 min-h-screen">
      <!-- Top Navigation Bar -->
      <div class="fixed top-0 left-72 right-0 z-40 bg-slate-800/90 backdrop-blur-xl border-b border-slate-700/50">
        <div class="flex items-center justify-between px-6 py-4">
          <!-- Left side - Page title -->
          <div class="flex items-center space-x-4">
            <h1 class="text-xl font-semibold text-white">{{ pageTitle }}</h1>
            <span class="text-sm text-slate-400">{{ pageSubtitle }}</span>
          </div>
          
          <!-- Right side - Navigation items -->
        <div class="flex items-center space-x-4">
            <!-- Cart Button (if needed) -->
            <button v-if="showCartButton" @click="$emit('cart-click')" class="relative p-2 text-slate-400 hover:text-emerald-400 transition-colors rounded-lg">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-2.5 5M7 13l2.5 5m6-5v6a2 2 0 01-2 2H9a2 2 0 01-2-2v-6m8 0V9a2 2 0 00-2-2H9a2 2 0 00-2 2v4.01"/>
              </svg>
              <div v-if="cartItemCount > 0" class="absolute -top-1 -right-1 w-5 h-5 bg-emerald-500 rounded-full flex items-center justify-center">
                <span class="text-xs text-white font-medium">{{ cartItemCount }}</span>
              </div>
            </button>

            <!-- Notifications -->
            <button class="relative p-2 text-slate-400 hover:text-emerald-400 transition-colors rounded-lg">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-5 5v-5zM15 17H9a2 2 0 01-2-2V5a2 2 0 012-2h6a2 2 0 012 2v10z"/>
              </svg>
              <div class="absolute top-1 right-1 w-2 h-2 bg-emerald-400 rounded-full animate-pulse"></div>
            </button>

            <!-- Settings -->
            <button class="p-2 text-slate-400 hover:text-emerald-400 transition-colors rounded-lg">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/>
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
              </svg>
            </button>

            <!-- Avatar Dropdown -->
            <div class="relative">
              <button @click="showUserDropdown = !showUserDropdown" class="flex items-center space-x-3 p-2 rounded-lg hover:bg-slate-800/50 transition-colors">
                <div class="w-8 h-8 bg-gradient-to-br from-emerald-400 to-cyan-400 rounded-full flex items-center justify-center">
                  <span class="text-sm font-bold text-slate-900">{{ userInitials || 'U' }}</span>
                </div>
                <div class="hidden md:block text-left">
                  <p class="text-sm font-medium text-white">{{ userName || 'User' }}</p>
                  <p class="text-xs text-slate-400">{{ userTitle || 'Contractor' }}</p>
                </div>
                <svg class="w-4 h-4 text-slate-400" :class="{ 'rotate-180': showUserDropdown }" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                </svg>
              </button>

              <!-- Dropdown Menu -->
              <div v-if="showUserDropdown" class="absolute right-0 mt-2 w-64 bg-slate-800/95 backdrop-blur-xl border border-slate-700/50 rounded-2xl shadow-2xl shadow-black/20 py-2">
                <!-- User Info Header -->
                <div class="px-4 py-3 border-b border-slate-700/50">
                  <div class="flex items-center space-x-3">
                    <div class="w-12 h-12 bg-gradient-to-br from-emerald-400 to-cyan-400 rounded-full flex items-center justify-center">
                      <span class="text-lg font-bold text-slate-900">{{ userInitials || 'U' }}</span>
                    </div>
                    <div>
                      <p class="text-sm font-semibold text-white">{{ userName || 'User' }}</p>
                      <p class="text-xs text-slate-400">{{ userTitle || 'Contractor' }}</p>
                      <p class="text-xs text-emerald-400 font-medium">{{ isEmployee ? 'W-2 Employee Account' : 'Contractor Account' }}</p>
                    </div>
                  </div>
                </div>

                <!-- Menu Items -->
                <div class="py-2">
                  <router-link 
                    to="/profile" 
                    class="flex items-center space-x-3 px-4 py-2 text-slate-300 hover:bg-slate-700/50 hover:text-emerald-400 transition-colors"
                    @click="showUserDropdown = false"
                  >
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                    </svg>
                    <span>Profile & Certifications</span>
                  </router-link>
                  
                  <router-link 
                    to="/settings" 
                    class="flex items-center space-x-3 px-4 py-2 text-slate-300 hover:bg-slate-700/50 hover:text-emerald-400 transition-colors"
                    @click="showUserDropdown = false"
                  >
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/>
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                    </svg>
                    <span>Account Settings</span>
                  </router-link>
                  
                  <router-link 
                    to="/preferences" 
                    class="flex items-center space-x-3 px-4 py-2 text-slate-300 hover:bg-slate-700/50 hover:text-emerald-400 transition-colors"
                    @click="showUserDropdown = false"
                  >
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
                    </svg>
                    <span>Preferences</span>
                  </router-link>
                  
                  <router-link 
                    to="/user-support" 
                    class="flex items-center space-x-3 px-4 py-2 text-slate-300 hover:bg-slate-700/50 hover:text-emerald-400 transition-colors"
                    @click="showUserDropdown = false"
                  >
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192L5.636 18.364M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"/>
                    </svg>
                    <span>Support</span>
                  </router-link>
                </div>

                <!-- Sign Out Button -->
                <div class="px-4 py-2 border-t border-slate-700/50">
                  <button @click="logout" class="w-full flex items-center space-x-3 px-4 py-2 text-red-400 hover:text-red-300 hover:bg-red-500/10 rounded-lg transition-all duration-200">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
            </svg>
                    <span class="text-sm font-medium">Sign Out</span>
          </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Page Content -->
      <div class="pt-20 p-4">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { getLandingPageUrl } from '../../config/environment'
import { useUserStore } from '../../stores/userStore'

interface Props {
  pageTitle?: string
  pageSubtitle?: string
  showCartButton?: boolean
  cartItemCount?: number
}

withDefaults(defineProps<Props>(), {
  pageTitle: 'Page',
  pageSubtitle: '',
  showCartButton: false,
  cartItemCount: 0
})

defineEmits<{
  'cart-click': []
}>()

const userStore = useUserStore()

const showUserDropdown = ref(false)
const landingPageUrl = getLandingPageUrl()
const crewLevel = ref(localStorage.getItem('crew_level') || '')

// Computed properties
const isEmployee = computed(() => localStorage.getItem('user_type') === 'employee')
const isSupervisor = computed(() =>
  ['supervisor_1', 'supervisor_2', 'supervisor_3'].includes(crewLevel.value)
)
function fieldLink(slug: string) {
  if (isEmployee.value) {
    const employeePaths: Record<string, string> = {
      onsite: '/employee/onsite',
      'field-tickets': '/employee/field-tickets',
      dispatch: '/employee/dispatch',
      'tank-sheets': '/employee/tank-sheets',
      tanks: '/employee/tanks',
      'tank-watch': '/employee/tank-watch',
      'well-head-sheets': '/employee/well-head-sheets',
    }
    return employeePaths[slug] || '/employee/onsite'
  }
  const contractorPaths: Record<string, string> = {
    onsite: '/onsite',
    'field-tickets': '/field-tickets',
    dispatch: '/dispatch',
    'tank-sheets': '/tank-sheets',
    tanks: '/tanks',
    'tank-watch': '/tank-watch',
    'well-head-sheets': '/well-head-sheets',
  }
  return contractorPaths[slug] || '/onsite'
}
const userInitials = computed(() => userStore.userInitials)
const userName = computed(() => userStore.currentUser?.name || 'User')
const userTitle = computed(() => {
  if (!isEmployee.value) return userStore.currentUser?.userType === 'contractor' ? 'Contractor' : 'User'
  if (isSupervisor.value) {
    const map: Record<string, string> = {
      supervisor_1: 'Supervisor 1',
      supervisor_2: 'Supervisor 2',
      supervisor_3: 'Supervisor 3',
    }
    return map[crewLevel.value] || 'Supervisor'
  }
  return 'W-2 Employee'
})

function setCrewLevel(level: string) {
  crewLevel.value = level || ''
  if (level) localStorage.setItem('crew_level', level)
  else localStorage.removeItem('crew_level')
}

const handleProfileClick = () => {
  showUserDropdown.value = !showUserDropdown.value
}

const logout = () => {
  userStore.logout()
  setCrewLevel('')
  window.location.href = '/#/login'
}

const handleClickOutside = (event: Event) => {
  const target = event.target as HTMLElement
  if (!target.closest('.relative')) {
    showUserDropdown.value = false
  }
}

onMounted(() => {
  userStore.loadUserFromStorage()
  document.addEventListener('click', handleClickOutside)
  // Keep supervisor nav in sync (localStorage alone is not reactive)
  if (isEmployee.value) {
    const token = localStorage.getItem('auth_token') || ''
    fetch('/api/employee/dashboard', { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.json())
      .then((d) => {
        if (d?.employee?.crewLevel) setCrewLevel(d.employee.crewLevel)
      })
      .catch(() => {})
  }
})
onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>

<style scoped>
/* Background patterns */
.bg-grid-pattern {
  background-image: radial-gradient(circle, rgba(148, 163, 184, 0.3) 1px, transparent 1px);
  background-size: 50px 50px;
  animation: grid-move 20s linear infinite;
}

@keyframes grid-move {
  0% { background-position: 0 0; }
  100% { background-position: 50px 50px; }
}

/* Floating particles */
.particle {
  position: absolute;
  width: 4px;
  height: 4px;
  background: linear-gradient(45deg, #10b981, #06b6d4);
  border-radius: 50%;
  animation: float 6s ease-in-out infinite;
}

.particle-1 { top: 20%; left: 10%; animation-delay: 0s; }
.particle-2 { top: 60%; left: 80%; animation-delay: 2s; }
.particle-3 { top: 80%; left: 20%; animation-delay: 4s; }
.particle-4 { top: 40%; left: 70%; animation-delay: 1s; }
.particle-5 { top: 70%; left: 40%; animation-delay: 3s; }

@keyframes float {
  0%, 100% { transform: translateY(0px) rotate(0deg); opacity: 1; }
  50% { transform: translateY(-20px) rotate(180deg); opacity: 0.8; }
}

/* Navigation active states */
.nav-item.router-link-exact-active {
  @apply bg-gradient-to-r from-emerald-500/20 to-cyan-500/20 text-emerald-400 border-l-4 border-emerald-500;
}

.nav-item.router-link-exact-active svg {
  @apply text-emerald-400;
}

/* Custom scrollbar */
.custom-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: rgba(100, 116, 139, 0.5) transparent;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: rgba(100, 116, 139, 0.5);
  border-radius: 3px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: rgba(100, 116, 139, 0.8);
}

/* Navigation styles */
.nav-item {
  @apply flex items-center space-x-3 px-4 py-3 text-slate-300 rounded-xl hover:bg-slate-800/50 hover:text-emerald-400 transition-all duration-300;
}
</style>
